import React from 'react';
import { Form, Input, Switch } from 'antd';
import { useDataProvider, useNotify, useQuery, useRefresh } from 'react-admin';
import { createSubmitHandler } from '@src/components/Settings/utils';

const LdapSettingsForm = () => {
    const dataProvider = useDataProvider();
    const notify = useNotify()
    const refresh = useRefresh();
    const [form] = Form.useForm();
    const settingsName = "LDAP"

    /**
     * Read and written the way every other setting here is.
     *
     * It used to fetch with its own getList and save with its own copy of the
     * submit logic — which never told the view to refresh, so the status beside
     * it in the rail went on saying whatever it said before, and never wrote the
     * saved config back to the cached settings the rest of the app reads.
     */
    const { loaded, error, data: currentLdapSettings } = useQuery({
        type: 'getOne',
        resource: 'general_settings',
        payload: { id: settingsName }
    });

    if (!loaded && !error) {
        return null;
    }

    return (
        <>
            <Form form={form}
                labelAlign='left'
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 14 }}
                initialValues={{
                    ENABLED: currentLdapSettings?.['config']?.ENABLED
                }}
                onFinish={createSubmitHandler(settingsName, currentLdapSettings, dataProvider, notify, refresh)}>
                <Form.Item valuePropName='checked' label="Enable LDAP" name="ENABLED" initialValue={currentLdapSettings?.['config']?.ENABLED || false}>
                    <Switch defaultChecked={currentLdapSettings?.['config']?.ENABLED == true} />
                </Form.Item >
                <Form.Item
                    label="LDAP Host"
                    initialValue={currentLdapSettings?.['config']?.SERVER_URI}
                    name="SERVER_URI"
                    rules={[{ required: true, message: 'Please input Server URI' }]}
                >
                    <Input placeholder="ldap://ldap.organisation.com:389" />
                </Form.Item>
                <Form.Item
                    label="Bind DN"
                    initialValue={currentLdapSettings?.['config']?.BIND_DN}
                    name="BIND_DN"
                    rules={[{ message: 'Please input BIND_DN' }]}
                >
                    <Input placeholder="BIND_DN" />
                </Form.Item>
                <Form.Item
                    label="Bind Password"
                    initialValue={currentLdapSettings?.['config']?.BIND_PASSWORD}
                    name="BIND_PASSWORD"
                    rules={[{ message: 'Please input BIND_PASSWORD' }]}
                >
                    <Input.Password placeholder="BIND_PASSWORD" />
                </Form.Item>
                <Form.Item
                    label="User Search Base"
                    initialValue={currentLdapSettings?.['config']?.USER_SEARCH_BASE_DN}
                    name="USER_SEARCH_BASE_DN"
                    rules={[{ required: true, message: 'Please input USER_SEARCH_BASE_DN' }]}
                >
                    <Input placeholder="USER_SEARCH_BASE_DN" />
                </Form.Item>
                <Form.Item
                    label="Group Search Base"
                    initialValue={currentLdapSettings?.['config']?.GROUP_SEARCH_QUERY_BASE_DN}
                    name="GROUP_SEARCH_QUERY_BASE_DN"
                    rules={[{ required: true, message: 'Please input GROUP_SEARCH_QUERY_BASE_DN' }]}
                >
                    <Input placeholder="GROUP_SEARCH" />
                </Form.Item>
                <Form.Item
                    label="Group Search Query Filter"
                    initialValue={currentLdapSettings?.['config']?.GROUP_SEARCH_QUERY_FILTER}
                    name="GROUP_SEARCH_QUERY_FILTER"
                    rules={[{ required: false, message: 'Please input GROUP_SEARCH_QUERY_FILTER' }]}
                >
                    <Input placeholder="GROUP_SEARCH_QUERY_FILTER" />
                </Form.Item>
            </Form>
        </>
    )
}

export default LdapSettingsForm;